// Events API client — mirrors /app/mobile/src/lib/events-api.ts
import { apiFetch, BACKEND_URL } from './api';
import { KEYS, storage } from './storage';

export const listEvents = () =>
  apiFetch('/api/v1/events');

export const getEvent = (id) =>
  apiFetch(`/api/v1/events/${id}`);

export const createEvent = (payload) =>
  apiFetch('/api/v1/events', { method: 'POST', body: JSON.stringify(payload) });

export const patchEvent = (id, payload) =>
  apiFetch(`/api/v1/events/${id}`, { method: 'PATCH', body: JSON.stringify(payload) });

export const changeLifecycle = (id, target) =>
  apiFetch(`/api/v1/events/${id}/lifecycle`, { method: 'POST', body: JSON.stringify({ target_status: target }) });

export const rotateEventId = (id) =>
  apiFetch(`/api/v1/events/${id}/rotate-event-id`, { method: 'POST' });

export const createInvitation = (id, payload) =>
  apiFetch(`/api/v1/events/${id}/invitations`, { method: 'POST', body: JSON.stringify(payload) });

export const listInvitations = (id) =>
  apiFetch(`/api/v1/events/${id}/invitations`);

export const previewJoin = (payload) =>
  apiFetch('/api/v1/events/preview', { method: 'POST', body: JSON.stringify(payload) });

export const joinEvent = (payload) =>
  apiFetch('/api/v1/events/join', { method: 'POST', body: JSON.stringify(payload) });

export const listMembers = (id) =>
  apiFetch(`/api/v1/events/${id}/members`);

export const verifyEventAttendance = (eventId, payload) =>
  apiFetch(`/api/v1/events/${eventId}/attendance/verify`, { method: 'POST', body: JSON.stringify(payload) });

export const declineEventAttendance = (eventId, reason) =>
  apiFetch(`/api/v1/events/${eventId}/attendance/decline`, { method: 'POST', body: JSON.stringify({ reason }) });

export const approveMember = (eventId, memberId, reason) =>
  apiFetch(`/api/v1/events/${eventId}/members/${memberId}/approve`, { method: 'POST', body: JSON.stringify({ reason }) });

export const denyMember = (eventId, memberId, reason) =>
  apiFetch(`/api/v1/events/${eventId}/members/${memberId}/deny`, { method: 'POST', body: JSON.stringify({ reason }) });

export const suspendMember = (eventId, memberId, reason) =>
  apiFetch(`/api/v1/events/${eventId}/members/${memberId}/suspend`, { method: 'POST', body: JSON.stringify({ reason }) });

export const removeMember = (eventId, memberId, reason) =>
  apiFetch(`/api/v1/events/${eventId}/members/${memberId}/remove`, { method: 'POST', body: JSON.stringify({ reason }) });

export const restorePending = (eventId, memberId) =>
  apiFetch(`/api/v1/events/${eventId}/members/${memberId}/restore-pending`, { method: 'POST', body: JSON.stringify({}) });

export const listAudit = (eventId, limit = 50) =>
  apiFetch(`/api/v1/events/${eventId}/audit?limit=${limit}`);

export const geocodeSuggest = (q, limit = 8) =>
  apiFetch(`/api/v1/geocode/suggest?q=${encodeURIComponent(q)}&limit=${limit}`);

export async function fetchEventQrDataUrl(id, kind = 'event_id', token) {
  const at = storage.get(KEYS.accessToken);
  const q = new URLSearchParams({ kind });
  if (token) q.set('token', token);
  const resp = await fetch(`${BACKEND_URL}/api/v1/events/${id}/qr?${q.toString()}`, {
    headers: at ? { Authorization: `Bearer ${at}` } : undefined,
  });
  if (!resp.ok) throw new Error(`QR fetch failed: ${resp.status}`);
  const buf = await resp.arrayBuffer();
  const bytes = new Uint8Array(buf);
  let bin = '';
  for (let i = 0; i < bytes.byteLength; i++) bin += String.fromCharCode(bytes[i]);
  return `data:image/png;base64,${btoa(bin)}`;
}

export const EVENT_CATEGORIES = [
  { key: 'wedding', label: 'Wedding' },
  { key: 'birthday', label: 'Birthday' },
  { key: 'reunion', label: 'Reunion' },
  { key: 'vacation', label: 'Vacation' },
  { key: 'memorial', label: 'Memorial' },
  { key: 'conference', label: 'Conference' },
  { key: 'concert', label: 'Concert' },
  { key: 'school_event', label: 'School event' },
  { key: 'family_library', label: 'Family library' },
  { key: 'other', label: 'Other' },
];

export const RADIUS_PRESETS = [100, 250, 500, 1000];

// Phase 13b — Co-branding
export const patchEventCobranding = (id, enabled) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(id)}/cobranding`, { method: 'PATCH', body: JSON.stringify({ enabled }) });

export const patchBusinessProfile = (payload) =>
  apiFetch('/api/v1/users/me/business-profile', { method: 'PATCH', body: JSON.stringify(payload) });

export const uploadBusinessLogo = (base64) =>
  apiFetch('/api/v1/users/me/business-logo', { method: 'POST', body: JSON.stringify({ image_base64: base64 }) });

export const deleteBusinessLogo = () =>
  apiFetch('/api/v1/users/me/business-logo', { method: 'DELETE' });

